import { Chip } from "@mui/material";
import { EventStatus, IncidentCategory, IncidentCriticality, IncidentStatus, PlannedWorkCategory, PlannedWorkCriticality, PlannedWorkStatus } from "../../interfaces/IEventEnums";
import { blue, green, grey, lightGreen, orange, purple, red } from "@mui/material/colors";

interface StatusChipProps {
    status: EventStatus | IncidentStatus | PlannedWorkStatus;
    size?: "small" | "medium";
}

export const StatusChip = ({status, size}: StatusChipProps) => {

    const chipColor = (status: EventStatus | IncidentStatus | PlannedWorkStatus) => {
        switch (status) {
            case EventStatus.Apen:
                return { label: status, style: { backgroundColor: blue[200] } }
            case EventStatus.Lukket:
                return { label: status, style: { backgroundColor: grey[300] } }
            case IncidentStatus.Rapportert:
                return { label: status, style: { backgroundColor: blue[200] } }
            case IncidentStatus.Utredning:
                return { label: status, style: { backgroundColor: orange[300] } }
            case IncidentStatus.FeilrettingPagar:
                return { label: status, style: { backgroundColor: orange[300] } }
            case IncidentStatus.Evaluering:
                return { label: status, style: { backgroundColor: green[300] } }
            case IncidentStatus.ProvisoriskLost:
                return { label: status, style: { backgroundColor: lightGreen[300] } }
            case IncidentStatus.Lukket:
                return { label: status, style: { backgroundColor: grey[300] } }
            case PlannedWorkStatus.Forespurt:
                return { label: status, style: { backgroundColor: blue[200] } }
            case PlannedWorkStatus.Utredning:
                return { label: status, style: { backgroundColor: orange[300] } }
            case PlannedWorkStatus.VenterSvar:
                return { label: status, style: { backgroundColor: orange[300] } }
            case PlannedWorkStatus.Godkjent:
                return { label: status, style: { backgroundColor: green[300] } }
            case PlannedWorkStatus.Oppfolging:
                return { label: status, style: { backgroundColor: green[300] } }
            case PlannedWorkStatus.Lukket:
                return { label: status, style: { backgroundColor: grey[300] } }
            default:
                return { label: status, style: { backgroundColor: grey[300] } }
        }
    };

    return (
        <Chip
            size={size}
            {...chipColor(status)}
            sx={{ color: 'black' }}
            label={status}
        />
    );
}

interface CategoryChipProps {
    category: PlannedWorkCategory | IncidentCategory;
    criticality?: PlannedWorkCriticality | IncidentCriticality;
    size?: "small" | "medium";
}

export const CategoryChip = ({category, size}: CategoryChipProps) => {

    const chipColor = (category: PlannedWorkCategory | IncidentCategory) => {
        switch (category) {
            case PlannedWorkCategory.NormalLow:
                return { label: category, style: { backgroundColor: blue[200] } }
            case PlannedWorkCategory.Critical:
                return { label: category, style: { backgroundColor: red[300] } }
            case PlannedWorkCategory.Standard:
                return { label: category, style: { backgroundColor: green[300] } }
            case PlannedWorkCategory.NormalHigh:
                return { label: category, style: { backgroundColor: orange[300] } }
            case IncidentCategory.Medium:
                return { label: category, style: { backgroundColor: blue[200] } }
            case IncidentCategory.Critical:
                return { label: category, style: { backgroundColor: red[300] } }
            case IncidentCategory.Low:
                return { label: category, style: { backgroundColor: green[300] } }
            case IncidentCategory.High:
                return { label: category, style: { backgroundColor: orange[300] } }
            default:
                return { label: category, style: { backgroundColor: grey[300] } }
        }
    };

    return (
        <Chip
            size={size}
            {...chipColor(category)}
            sx={{ color: 'black' }}
            label={category}
        />
    );
}

export function CriticalityChip ({criticality, size}: {criticality: PlannedWorkCriticality | IncidentCriticality, size?: "small" | "medium"}) {
    const chipColor = (criticality: PlannedWorkCriticality | IncidentCriticality) => {
        switch (criticality) {
            case PlannedWorkCriticality.High:
                return { label: criticality, style: { backgroundColor: red[300] } }
            case PlannedWorkCriticality.Medium:
                return { label: criticality, style: { backgroundColor: orange[300] } }
            case PlannedWorkCriticality.Low:
                return { label: criticality, style: { backgroundColor: green[300] } }
            case IncidentCriticality.A:
                return { label: criticality, style: { backgroundColor: red[300] } }
            case IncidentCriticality.B:
                return { label: criticality, style: { backgroundColor: orange[300] } }
            case IncidentCriticality.C:
                return { label: criticality, style: { backgroundColor: green[300] } }
            default:
                return { label: criticality, style: { backgroundColor: grey[300] } }
        }
    };

    return (
        <Chip
            size={size}
            {...chipColor(criticality)}
            sx={{ color: 'black' }}
            label={criticality}
        />
    );
}

export function AssignmentChip ({status, size}: {status: string, size?: "small" | "medium"}) {
    const chipColor = (status: string) => {
        if (!status) return { label: '', style: {} }
        const uppercasedStatus = status.toUpperCase()
        if (uppercasedStatus === 'ÅPEN') {
          return { label: status, style: { backgroundColor: blue[200] } }
        }
        if (uppercasedStatus === 'UTSATT AV EB') {
          return { label: status, style: { backgroundColor: orange[300] } }
        }
        if (uppercasedStatus === 'UTSATT AV KUNDE') {
          return { label: status, style: { backgroundColor: purple[200] } }
        }
        if (uppercasedStatus === 'UTSATT AV ENTREPRENØR') {
          return { label: status, style: { backgroundColor: red[300] } }
        }
        if (uppercasedStatus === 'FERDIG') {
          return { label: status, style: { backgroundColor: green[300] } }
        }
        if (uppercasedStatus === 'PROVISORISK LØST') {
          return { label: status, style: { backgroundColor: lightGreen[300] } }
        }
        if (uppercasedStatus === 'KANSELLERT') {
          return { label: status, style: { backgroundColor: grey[300] } }
        }
      }

    return (
        <Chip
            size={size}
            {...chipColor(status)}
            sx={{ color: 'black' }}
            label={status}
        />
    );
}